module.exports = __webpack_public_path__ + "static/scale-model-of-alexandria-virginia-a535b0e61becde2f21f1219108bca584.png";